module.exports = __webpack_public_path__ + "static/media/9client.33f069c1.png";